import React from "react";
import cx from "classnames";

import Placeholder, { Rect } from "components/Placeholder";

const StrainCardPlaceholder: React.FC<{
  className?: string;
  orientation?:
    | "vertical"
    | "horizontal"
    | {
        desktop: "vertical" | "horizontal";
        mobile: "vertical" | "horizontal";
      };
  productsView?: boolean;
  compareView?: boolean;
  buttonsView?: boolean;
  comparePricesView?: boolean;
  showDescription?: boolean;
}> = ({
  className,
  orientation = "vertical",
  productsView,
  compareView,
  buttonsView,
  comparePricesView,
  showDescription,
  ...others
}) => {
  const isOrientationObject = typeof orientation === "object";
  const isVerticalOrMobileVertical =
    orientation === "vertical" ||
    (isOrientationObject && orientation.mobile === "vertical");
  const isHorizontalOrMobileHorizontal =
    orientation === "horizontal" ||
    (isOrientationObject && orientation.mobile === "horizontal");
  const isVerticalDesktop =
    isOrientationObject && orientation.desktop === "vertical";
  const isHorizontalDesktop =
    isOrientationObject && orientation.desktop === "horizontal";

  return (
    <div className={cx("flex flex-col", className)} {...others}>
      <div
        className={cx({
          "md:p-lg": isHorizontalDesktop,
          "md:p-md": isVerticalDesktop,
          "p-lg": isHorizontalOrMobileHorizontal,
          "p-md": isVerticalOrMobileVertical,
        })}
      >
        <div
          className={cx("flex", {
            "flex-col": isVerticalOrMobileVertical,
            "flex-row": isHorizontalOrMobileHorizontal,
            "md:flex-col": isVerticalDesktop,
            "md:flex-row": isHorizontalDesktop,
          })}
        >
          <div
            className={cx("relative w-full", {
              "md:mr-sm md:max-w-[75px] md:mb-0": isHorizontalDesktop,
              "md:mx-auto md:mb-sm md:max-w-[215px]": isVerticalDesktop,
              "mr-sm max-w-[75px]": isHorizontalOrMobileHorizontal,
              "mx-auto mb-sm": isVerticalOrMobileVertical,
            })}
          >
            <Placeholder
              width="100%"
              viewBox="0 0 100 100"
              preserveAspectRatio="xMinYMin meet"
              className="flex-shrink-0"
            >
              <Rect width="100" height="100" />
            </Placeholder>
          </div>
          <div>
            <Placeholder width="100%" height="124">
              <Rect width="55" height="28" />
              <Rect y="36" width="50%" height="18" />
              <Rect y="64" width="85%" height="12" />
              <Rect y="86" width="110" height="15" />
              <Rect y="111" width="110" height="13" />
            </Placeholder>
            <div className="flex mt-sm">
              <Placeholder width="80" height="16" className="mb-xs mr-sm">
                <Rect width="100%" height="100%" />
              </Placeholder>
              <Placeholder width="80" height="16" className="mb-xs mr-sm">
                <Rect width="100%" height="100%" />
              </Placeholder>
            </div>
            {comparePricesView && (
              <Placeholder width="100%" height="58">
                <Rect y="2" width="45%" height="14" />
                <Rect y="22" width="30%" height="14" />
              </Placeholder>
            )}
          </div>
        </div>
        {showDescription && (
          <Placeholder width="100%" height="58">
            <Rect y="2" width="100%" height="14" />
            <Rect y="22" width="100%" height="14" />
            <Rect y="42" width="80%" height="14" />
          </Placeholder>
        )}
      </div>

      {(productsView || compareView) && (
        <div className="p-sm border-t border-light-grey">
          {productsView && (
            <Placeholder width="100%" height="63">
              <Rect y="2" width="60%" height="16" />
              <Rect y="32" width="49%" height="30" />
              <Rect x="51%" y="32" width="49%" height="30" />
            </Placeholder>
          )}
          {compareView && (
            <Placeholder width="100%" height="47">
              <Rect y="0" width="40%" height="16" />
              <Rect y="22" width="24" height="24" />
              <Rect y="26" x="28" width="65" height="16" />
              <Rect y="22" x="100" width="24" height="24" />
              <Rect y="26" x="127" width="65" height="16" />
            </Placeholder>
          )}
        </div>
      )}
      {(buttonsView || comparePricesView) && (
        <div className="p-sm">
          {buttonsView && (
            <Placeholder width="100%" height="30" className="mb-sm">
              <Rect y="0" rx="16" ry="16" width="49%" height="30" />
              <Rect y="0" x="51%" rx="16" ry="16" width="49%" height="30" />
            </Placeholder>
          )}
          {comparePricesView && (
            <Placeholder width="100%" height="30" className="mb-sm">
              <Rect y="0" x="3%" rx="16" ry="16" width="95%" height="30" />
            </Placeholder>
          )}
        </div>
      )}
    </div>
  );
};

export default StrainCardPlaceholder;
